import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { TimeField } from '../components/Table/fields/TimeField';
import { statuses } from './statuses';
import { service } from './service';
import { servicePackage } from './servicePackage';
import { group } from './group';
import { serviceProvider } from './serviceProvider';
import { CommentWall } from '../components/Comment/CommentWall';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPTimeField } from '../components/Table/fields/SPTimeField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPSelectWithOutAutocomplete } from '../components/Table/fields/SPSelectWithOutAutocompleteField';
import { FileField } from '../components/Table/fields/FileField';
import { ServiceReservationFinance } from '../components/LegalAndFinance/ServiceReservationFinance';
import { ServiceReservationLog } from '../components/Log/ServiceReservationLog';
import { userByRole } from './userByRole';
import { CustomFieldForServiceReservationStaff } from '../components/Table/fields/CustomFieldForServiceReservationStaff';
import { address } from './address';
import { SPSelectAddressField } from '../components/Table/fields/SPSelectAddressField';

export const serviceReservationView: SchemaWithClient<any> = {
  name: 'Service Reservations View',
  pluralName: 'Service Reservations',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
    {
      id: 2,
      label: 'Finances',
      name: 'finances',
      type: 'custom',
      renderer: ServiceReservationFinance,
    },
    {
      id: 3,
      label: 'Comments',
      name: 'comments',
      type: 'custom',
      renderer: CommentWall,
      rendererType: 'service_reservations',
    },
    {
      id: 4,
      label: 'History',
      name: 'logs',
      type: 'custom',
      renderer: ServiceReservationLog,
    },
  ],
  breadcrumb: ['Group', 'Activity Reservation', 'Service Reservation'],
  columns: {
    service_reservation_status: {
      name: 'Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceReservationStatus
      ),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(
        statuses.serviceReservationStatus
      ),
      switchboard: true,
      url: statuses.serviceReservationStatus.client.getAllPath,
      tempSchema: statuses.serviceReservationStatus,
      style: {
        marginBottom: '30px',
      },
    },

    system_configuration: {
      name: 'System Confirmation',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      readOnly: true,
      style: {},
    },
    files: {
      name: 'Manual Confirmation',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: FileField,
      fieldType: 'file',
      style: {
        marginBottom: '30px',
      },
    },

    group: {
      name: 'Group',
      fieldRenderer: SelectField.tableAdapter(group),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(group),
      url: group.client.getAllPath,
      tempSchema: group,
      switchboard: true,
      accordingTo: 'date',
      style: {
        background: '#256861',
        color: '#fff',
      },
    },

    activity_reservation: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(enumItems.activityReservation),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.activityReservation),
      url: enumItems.activityReservation.client.getAllPath,
      tempSchema: enumItems.activityReservation,
      switchboard: true,
      accordingTo: 'group',
      style: {
        background: '#256861',
        color: '#fff',
      },
    },
    size: {
      name: 'Group Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    service_package: {
      name: 'Service Group',
      fieldRenderer: SelectField.tableAdapter(servicePackage()),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(servicePackage()),
      url: servicePackage().client.getAllPath,
      tempSchema: servicePackage(),
      switchboard: true,
      accordingTo: 'activity_reservation',
      readOnly: true,
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(serviceProvider),
      url: serviceProvider.client.getAllPath,
      tempSchema: serviceProvider,
      switchboard: true,
      accordingTo: 'activity_reservation',
      readOnly: true,
    },
    service: {
      name: 'Service',
      fieldRenderer: SelectField.tableAdapter(service),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(service),
      url: service.client.getAllPath,
      tempSchema: service,
      switchboard: true,
      accordingTo: 'service_provider',
      readOnly: true,
    },
    selected_staff: {
      name: 'Event Staff',
      fieldRenderer: SelectField.tableAdapter(userByRole('9')),
      slidePaneFieldRenderer: CustomFieldForServiceReservationStaff,
      url: userByRole('9').client.getAllPath,
      tempSchema: userByRole('9'),
      switchboard: true,
      accordingTo: 'activity_reservation',
    },

    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },
    date: {
      name: 'Date',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    start_time: {
      name: 'Time',
      fieldRenderer: TimeField,
      slidePaneFieldRenderer: SPTimeField,
      fieldType: 'time',
    },
    meeting_place: {
      name: 'Meeting Place',
      fieldRenderer: SelectField.tableAdapter(address),
      slidePaneFieldRenderer: SPSelectAddressField.tableAdapter(address),
      switchboard: true,
      url: address.client.getAllPath,
      tempSchema: address,
    },
    venue: {
      name: 'Venue',
      fieldRenderer: SelectField.tableAdapter(address),
      slidePaneFieldRenderer: SPSelectAddressField.tableAdapter(address),
      switchboard: true,
      url: address.client.getAllPath,
      tempSchema: address,
    },
    /* custom_fields: {
      name: 'Custom Fields',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: CustomFields,
      fieldType: 'custom',
      hideInTableView: true,
      withoutNameColumn: true,
    },*/
    /*
    activity_reservation: {
      name: 'Activity Reservation',
      fieldRenderer: SelectField.tableAdapter(activityReservation()),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(activityReservation()),
      url: activityReservation().client.getAllPath,
      tempSchema: activityReservation(),
      switchboard: true,
      accordingTo: 'group',
    },*/

    /*service_se_status: {
      name: 'Service SE Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceSeStatus
      ),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(
        statuses.serviceSeStatus
      ),
      switchboard: true,
      url: statuses.serviceSeStatus.client.getAllPath,
      tempSchema: statuses.serviceSeStatus,
    },
    service_sp_status: {
      name: 'Service SP Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.serviceSpStatus
      ),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(
        statuses.serviceSeStatus
      ),
      switchboard: true,
      url: statuses.serviceSpStatus.client.getAllPath,
      tempSchema: statuses.serviceSpStatus,
    },*/

    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  viewTable: 'service_reservations',
  client: new Client(`/service-reservations-view`),
};
